const INFO = {
	main: {
		title: "Keefe Oentoro",
		name: "Keefe Oentoro",
		email: "keefenoentoro@gmail.com",
		logo: "/logo.svg",
	},

	socials: {
		github: "https://github.com/Kulkoen",
		linkedin: "https://linkedin.com/in/keefeoentoro",
	},

	homepage: {
		title: "Hi, I'm Keefe!",
		description:
			"I’m a Software Engineer at Young Corporation, where I build smart home systems and internal tools that streamline workflows across teams.\
			Guided by a lifelong love of technology and a CS degree from Georgia Tech, my goal is simple: use software and strategic leadership to make\
			life easier and better for the people around me.",
	},

	about: {
		title: "I’m Keefe Oentoro. Here is more about me!",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made and I hope to do many more in the near future. Many of these projects available for others to explore on GitHub. If you have any questions, please feel free to reach out!",
	},

	projects: [
		{
			title: "University Student Connection App",
			description:
				"Application that allows students to quickly connect with other students on campus.",
			logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/1280px-React-icon.svg.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=thumbnail&_=20220125121207",
			linkText: "View Project",
			link: "https://github.com/orgs/DenkDevs/repositories",
			tags: ["React Native", "Firebase"],
		},

		{
			title: "Artificially Intelligent Baby Monitor",
			description:
				"Baby monitor that uses AI to detect baby's emotions and environment to alert parents.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/Kulkoen/BabyFaceAI",
			tags: ["Python"],
		},

		{
			title: "Simple Airline Management System",
			description:
				"Database system that kept track of airlines, flights, and passengers.",
			logo: "https://www.vectorlogo.zone/logos/mysql/mysql-icon.svg",
			tags: ["MySQL", "Java"],
		},

		{
			title: "Android Studio Tower Defense Game",
			description: "Tower defense game made to work on Android devices.",
			logo: "https://developer.android.com/static/images/brand/android-head_flat.png",
			linkText: "View Project",
			link: "https://github.com/Kulkoen/ShingekiNoCowjin",
			tags: ["Java", "Android"],
		},
	],

	projectsInProgress: [
		{
			title: "Breakbook",
			description:
				"Mobile application to help me organize my breaking moves and notes.",
			stage: "POLISHING",
			link: "https://breakbook.kulkoen.com",
			linkText: "View Project",
			logo: "/Logo.png",
			tags: ["React Native", "iOS", "Android"],
		},
	],
};

export default INFO;
